module.exports = __webpack_public_path__ + "img/dashboard.4e24d22c.png";